export enum WorkModeEnum {
  Office = 1,
  ConcludedHomeOfficeRemote = 2,
  ContactWithPersonWithCovidRemote = 3,
  CovidPositiveRemote = 4,
  OnSite = 5,
  OnTraining = 6,
  HomeOfficeOnDemand = 7
}
